import { ref, computed } from 'vue'
import { login as loginService, logout as logoutService } from '../services/auth.js'

// Module-level singleton — shared across all component instances
const token = ref(localStorage.getItem('auth_token') || null)
const user  = ref(JSON.parse(localStorage.getItem('sicamex_user') || 'null'))

export function useAuth() {
  const isAuthenticated = computed(() => !!token.value)
  const companyId       = computed(() => user.value?.company?.id   || null)
  const chainId         = computed(() => user.value?.chain?.id     || null)
  const userId          = computed(() => user.value?.id            || null)
  const userName        = computed(() => [user.value?.name, user.value?.lastname].filter(Boolean).join(' ') || '')
  const companyName     = computed(() => user.value?.company?.name || '')

  async function login(email, password) {
    const data = await loginService(email, password)
    token.value = data.auth_token
    user.value  = data
    localStorage.setItem('auth_token',    data.auth_token)
    localStorage.setItem('sicamex_user', JSON.stringify(data))
    return data
  }

  function logout() {
    if (token.value) logoutService(token.value)
    token.value = null
    user.value  = null
    localStorage.clear()
  }

  return { token, user, isAuthenticated, companyId, chainId, userId, userName, companyName, login, logout }
}
